import { useState } from "react";
import MyProcessesTable from "./MyProcessesTable";
import useMyProcesses from "./useMyProcesses";
import FilterDropdown from "~/components/FilterDropdown";
import StatusBadge from "~/Pages/Process/components/StatusBadge";
import { Chip } from "primereact/chip";
import { Dropdown } from "primereact/dropdown";

const MyProcesses = ({ allEntities }) => {
  const {
    data,
    loading,
    isDataAvailable,
    totalRecord,
    onPageChange,
    rows,
    page,
    sortMeta,
    onSort,
    chipData,
    selectedFilters,
    setSelectedFilters,
    applyFilters,
    setSelectedValues,
    deSelectAll,
    serviceSubOptions,
    handleRemoveFilter,
    getStatus,
    getService,
    shouldHideServiceFilter,
    searchQuery,
    setSearchQuery,
    period,
    setPeriod,
  } = useMyProcesses({ allEntities });

  const durationOptions = [
    { name: "All Time", code: "all" },
    { name: "Last 7 Days", code: 7 },
    { name: "Last 30 Days", code: 30 },
    { name: "Last 180 Days", code: 180 },
    { name: "Last 365 Days", code: 365 },
  ];

  const createStatusOption = (name, code, color) => ({
    name,
    code,
    color,
    icon: () => (
      <span className="mr-2 process__status__badge">
        <StatusBadge
          status={{
            primary_color: color,
          }}
        />
      </span>
    ),
  });

  const filterOptions = [
    {
      name: "Status",
      id: "status",
      suboptions: [
        createStatusOption("Not Started", "not-started", "#757575"),
        createStatusOption("In Progress", "in-progress", "#326FD1"),
        createStatusOption("Completed", "completed", "#188A42"),
        createStatusOption("Overdue", "overdue", "#EAB308"),
      ],
    },
    {
      name: "Flagged",
      id: "flagged",
      suboptions: [
        {
          name: "Flagged",
          code: "true",
          icon: () => (
            <i
              className="pi pi-flag-fill mr-2"
              style={{ color: "var(--lara-light-red-500)", fontSize: "16px" }}
            />
          ),
        },
      ],
    },
    ...(!shouldHideServiceFilter
      ? [
          {
            name: "Service Line",
            id: "service_line",
            suboptions: serviceSubOptions,
          },
        ]
      : []),
  ];
  return (
    <div className="my_processes--container border-gray mt-4">
      <p className="heading mb-3"> My Processes</p>
      <div className="flex justify-content-end">
        <div className="flex-1">
          <div className="flex align-items-center gap-2">
            <Dropdown
              value={period}
              onChange={(e) => {
                // Only update state; useEffect([period]) will refetch with correct dates
                setPeriod(e.value);
              }}
              options={durationOptions}
              optionLabel="name"
              optionValue="code"
              placeholder="All Time"
              className="w-12rem"
            />
            <div className="input-wrapper-container width__full">
              <span className="pi pi-search"></span>
              <input
                type="text"
                placeholder="Search project by entity name, service line or country"
                className="appearance-none outline-none w-full"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="flex justify-content-end mb-3">
          <FilterDropdown
            groupedOptions={filterOptions}
            filterCount={chipData?.length}
            value={selectedFilters}
            onChange={(e) => {
              setSelectedValues(e.grouped);
              setSelectedFilters(e.value);
            }}
            applyFilter={applyFilters}
            deSelectAll={deSelectAll}
            placeholder="All events"
          />
        </div>
      </div>
      <p className="helper-text m-0">
        This filter applies to the list below, showing processes based on their
        Start Date.
      </p>
      <div className="filter-chips-container mb-3">
        {chipData?.length ? `Filters (${chipData?.length})` : null}
        {chipData?.map((data) => (
          <Chip
            key={`${data?.category}-${data?.value}`}
            label={
              <span
                key={`${data?.category}-${data?.value}`}
                className="filter__chip"
              >
                {data?.category === "status" ? (
                  <span>
                    <span className="mr-2 process__status__badge">
                      <StatusBadge
                        status={{
                          primary_color: getStatus(data?.value)?.primary_color,
                        }}
                      />
                    </span>
                    {getStatus(data?.value)?.name}
                  </span>
                ) : data?.category === "flagged" ? (
                  <span>
                    <i
                      className="pi pi-flag-fill mr-2"
                      style={{
                        color: "var(--lara-light-red-500)",
                        fontSize: "16px",
                      }}
                    />{" "}
                    Flagged
                  </span>
                ) : (
                  getService(data?.value)?.name
                )}{" "}
                <span className="cross__icon">
                  <i
                    className="pi pi-times"
                    onClick={() => handleRemoveFilter(data)}
                  />
                </span>
              </span>
            }
            removable={false}
          />
        ))}
      </div>
      <MyProcessesTable
        data={data}
        loading={loading}
        isDataAvailable={isDataAvailable}
        totalRecords={totalRecord}
        onPageChange={onPageChange}
        rows={rows}
        page={page}
        sortMeta={sortMeta}
        onSort={onSort}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default MyProcesses;
